<template>
  <div id="tab-license-add-complete" v-if="registeredLicense">
    <div class="vx-row mt-8">
      <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <table v-if="selectedLicenseCategory === licenseCategory.BOAT">
            <tr>
              <td class="font-semibold mb-2"><h4>小型船舶種別：</h4></td>
              <td>
                <h4>{{ licenceGrade }}</h4>
              </td>
            </tr>
            <tr>
              <td class="font-semibold mb-2"><h4>有効期限：</h4></td>
              <td>
                <h4>{{ expirationDate }}まで</h4>
              </td>
            </tr>
            <tr>
              <td class="font-semibold mb-2"><h4>画像の有無：</h4></td>
              <td>
                <h4>{{ isRegisteredPicture }}</h4>
              </td>
            </tr>
          </table>

          <table v-if="selectedLicenseCategory === licenseCategory.MARINE">
            <tr>
              <td class="font-semibold mb-2"><h4>免許区分：</h4></td>
              <td>
                <h4>{{ registeredLicense.name }}</h4>
              </td>
            </tr>
            <tr>
              <td class="font-semibold mb-2"><h4>階級：</h4></td>
              <td>
                <h4>{{ licenceGrade }}</h4>
              </td>
            </tr>
            <tr>
              <td class="font-semibold mb-2"><h4>有効期限：</h4></td>
              <td>
                <h4>{{ expirationDate }}まで</h4>
              </td>
            </tr>
            <tr>
              <td class="font-semibold mb-2"><h4>画像の有無：</h4></td>
              <td>
                <h4>{{ isRegisteredPicture }}</h4>
              </td>
            </tr>
          </table>

          <table v-if="selectedLicenseCategory === licenseCategory.OTHERS">
            <tr>
              <td class="font-semibold mb-2"><h4>免許/資格名：</h4></td>
              <td>
                <h4>{{ registeredLicense.name }}</h4>
              </td>
            </tr>
            <tr>
              <td class="font-semibold mb-2"><h4>有効期限：</h4></td>
              <td>
                <h4>{{ expirationDate }}まで</h4>
              </td>
            </tr>
            <tr>
              <td class="font-semibold mb-2"><h4>画像の有無：</h4></td>
              <td>
                <h4>{{ isRegisteredPicture }}</h4>
              </td>
            </tr>
          </table>
        </vs-col>
      </vs-row>
    </div>
    <div class="vx-row mt-8">
      <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button class="mx-4" type="border" @click="onClickContinue"
            >続けて登録する</vs-button
          >
          <vs-button class="mx-4" @click="onClickBackToView"
            >詳細へ戻る</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import LicenseMixin from "@/mixins/LicenseMixin";
import { DateUtil } from "@/utils";
const { mapState, mapActions, mapGetters } = createNamespacedHelpers(
  "enterpriseLicenseAdd"
);

export default {
  mixins: [LicenseMixin],
  computed: {
    ...mapGetters(["isRegisteredPicture"]),
    ...mapState({
      selectedLicenseCategory: state => state.selectedLicenseCategory,
      registeredLicense: state => state.registeredLicense
    }),

    expirationDate() {
      let date = DateUtil.toDate(this.registeredLicense.expiration_date);
      return DateUtil.toEMD_ja(date);
    },

    licenceGrade() {
      return this.findLicenseLabelById(this.registeredLicense.license_type_id);
    }
  },
  methods: {
    ...mapActions(["cleanUp"]),
    onClickBackToView() {
      this.$router.push({
        name: "enterprise-management-user-view",
        params: { userId: this.$route.params.userId }
      });
    },
    onClickContinue() {
      this.cleanUp();
      this.$emit("reset");
    }
  }
};
</script>

<style lang="scss">
#tab-license-add-complete {
  table {
    width: 400px;
  }
  td {
    height: 50px;
  }
}
</style>
